module.exports = __webpack_public_path__ + "img/kq.c4e044ef.svg";